import $ from 'jquery';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import useApiUrl from '../../framework/hooks/useApiUrlHook';

export default function CaseSlider({ pro = false }) {
    const apiUrl = useApiUrl();
    const [cases, setCases] = useState([]);

    const getCases = () => {
        axios
            .get(`${apiUrl}/case/slider`)
            .then((response) => {
                setCases(response.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        if (apiUrl != null) getCases();
    }, [apiUrl]);

    return (
        <div className={`case-slider-active sections section-w logo-light ${pro ? 'pro-case-slider-active' : ''}`}>
            <Swiper
                spaceBetween={50}
                slidesPerView={1}
                modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                loop
                autoplay={{ delay: 3000 }}
                pagination={{ el: '.case-pagination', clickable: true, dynamicBullets: false }}
                navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
            >
                {cases?.map((c) => (
                    <SwiperSlide key={c.id}>
                        <div
                            className="case-slide-wrap"
                            style={{
                                backgroundImage: `url(${apiUrl}/img/extern/ratio/www.bandwerk.nl/klanten_sfeer/1325/665/100/${c.image})`,
                            }}
                        >
                            <div className="case-content-wrapper">
                                <h2>{c.klant}</h2>
                                <a href={`/succesverhalen/${c.fancy_name}`}>
                                    <h3>{c.titel}</h3>
                                </a>
                                <div className="case-tags">
                                    {c?.diensten?.map((dienst, index) => (
                                        <a key={index} href={`/onze-diensten/${dienst.url}`}>
                                            {dienst.titel}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            {/* If we need pagination */}
            <div className="swiper-pagination case-pagination" />
        </div>
    );
}
